import history from '@/browserHistory';

/* eslint-disable max-statements */
/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable complexity */
import {isBoolean} from 'lodash-es';
import {confirm} from '@/components/ConfirmDialog';
import {perfLogger} from '@/buried/performance';
import routers, {buildPath, ServerConfig, tocRouters} from '@/config/routers';
import {IRteToken, UserDetail} from '@/interface';
import {
    fixRepositoryName,
    isPersonal,
} from '@/domains/space/Repository/Utils/fixRepositoryNameWithPersonal';
import sdk from '@/sdk';
import {
    ErrorCode,
    SuccessCode,
    WizKnownError,
    WizNoPermissionError,
} from '@/sdk/common/error';
import * as store from '@/store';
import {tokenRetry} from '@/utils/tokenRetry';
import {tokenErrorToast} from '@/components/errorToast/tokenError';
import {getDocsInMeeting} from '@/utils/document/meetingMode';
import {feLogger, openPageUrl} from '@/buried';
import {VISIBILITY_STATE} from '@/constants/common';
import {getLogDocType} from '@/buried/performance/utils';
import {EDITOR_MODE} from '@/Constant';
import {DOC_TYPE} from '@/constants/document/doc';
import {getUrlParams} from '@/utils/kuQuery';
import {feLoggerSetUid} from '../buried';
import weirwood from '../weirwood';
import {docEditAble} from '@/store/util';
import {logAssociations} from '@/buried/association';

function getNewUrl(
    spaceGuid: string,
    groupGuid: string,
    repositoryGuid: string,
    docGuid?: string
) {
    let path = routers.Knowledge.path;
    const pathName = location.pathname;
    const hash = location.hash;
    const search = location.search;
    const isRecycleBin = pathName.includes('/recycleBin');
    const isSetting = pathName.includes('/setting');
    const isHomeTag = pathName.includes('/homeTag');
    const isEditionPage = pathName.includes('/edition');
    if (isRecycleBin) {
        path = routers.Knowledge.recycleBinPath;
    } else if (isSetting) {
        path = routers.Knowledge.settingPath;
    } else if (isHomeTag) {
        path = routers.Knowledge.homeTagPath;
    } else if (isEditionPage) {
        path = routers.Knowledge.docEditionPath;
    }
    const url = buildPath(path, {
        spaceGuid: spaceGuid,
        groupGuid: groupGuid,
        repositoryGuid: repositoryGuid,
        docGuid: docGuid || '',
    });
    return `${url}${search}${hash}`;
}

// 获取知识库无权限信息 文档/知识库页面共用
const getRepositoryNoPermissionInfo = ({
    spaceGuid,
    groupGuid,
    repositoryGuid,
    result,
}: {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    result: any;
}) => {
    const repository = result.repository || {};
    const doc = result.doc || {};
    const r = {
        spaceGuid,
        groupGuid,
        repositoryGuid,
        name: repository.repositoryName,
        ownerType: repository.ownerType,
        sourceType: repository.sourceType,
        docName: doc?.docName,
        userAvatar: repository.userAvatar,
        external: repository?.external || false,
    };
    fixRepositoryName(r);
    const message = JSON.stringify({
        repositoryName: r.name,
        ownerType: r.ownerType,
        sourceType: r.sourceType,
        docName: r.docName,
    });
    return {
        r,
        error: new WizNoPermissionError(message, null, {
            result: message,
        }),
    };
};

export const arrangeRepositoryNoPermission = ({
    spaceGuid,
    groupGuid,
    repositoryGuid,
    result,
}: {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    result: any;
}) => {
    const repository = result.repository || {};
    const {r, error} = getRepositoryNoPermissionInfo({
        spaceGuid,
        groupGuid,
        repositoryGuid,
        result,
    });
    store.setCurRepositoryName(r.name || repository.repositoryName);
    store.setCurRepository(r);
    store.setCurRepositoryError(error);
    return error;
};

const arrangeRepositoryNotFound = (
    {result}: {result: any},
    curDocGuid?: string
) => {
    // 如果是链接错误 则重新跳转
    if (result.wikiInfo) {
        const {spaceGuid, groupGuid, repositoryGuid, docGuid} = result.wikiInfo;
        location.replace(
            getNewUrl(
                spaceGuid,
                groupGuid,
                repositoryGuid,
                docGuid || curDocGuid
            )
        );
        return;
    }
    store.setCurRepositoryError(
        new WizKnownError('知识库没有找到', 404, null, '404')
    );
};

// 保存读写合一小流量数据到 store
function setRwUnifyData(userRwFlow: boolean, rwFlow: boolean) {
    if (isBoolean(userRwFlow) && isBoolean(rwFlow)) {
        store.setRwMode(userRwFlow || !rwFlow);
    }
}

const routerPublicPath = process.env.REACT_APP_ROUTER_PUBLIC_PATH || '';
const getDocGuidFromUrl = () => {
    const pathData = location.pathname.split('/');
    const baseNum = routerPublicPath ? 2 : 1;
    const docGuid = pathData[baseNum + 4];
    return docGuid;
};
const arrangePersonalPage = (repository: Repository) => {
    // @todo personalPage 跳转
    // 跳转到跳转到上一次访问页面 或第一个 或成员管理
    const {spaceGuid, groupGuid, repositoryGuid, defaultDocGuid} = repository;
    const url = buildPath(routers.Knowledge.path, {
        spaceGuid,
        groupGuid,
        repositoryGuid,
        docGuid: defaultDocGuid || 'members',
    });
    defaultDocGuid &&
        getDocumentInfo({
            spaceGuid,
            groupGuid,
            repositoryGuid,
            docGuid: defaultDocGuid,
        });
    history.replace(url);
};

export const getRepositoryInfo = async ({
    spaceGuid,
    groupGuid,
    repositoryGuid,
}: {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
}) => {
    try {
        store.setCurRepositoryName('');
        const result = await sdk.infoQuery({
            spaceGuid,
            groupGuid,
            repositoryGuid,
            needRepositoryData: true,
        });
        if (result) {
            const {repoStatus, userRwFlow, rwFlow} = result;
            setRwUnifyData(userRwFlow, rwFlow);
            result.user && store.setUser(result.user);
            perfLogger.docPagePaint.paintStop();
            const repository = result.repository || {};
            const isHomePage = !getDocGuidFromUrl();
            const isPersonalRepo = isPersonal(repository) && isHomePage;
            if (repoStatus === SuccessCode) {
                fixRepositoryName(repository);
                store.setCurRepositoryName(repository.name);
                store.setCurRepository(repository);
                store.setCurRepositoryError(null);
                // 如果是个人知识库 跳转到上一次访问页面 或第一个 或成员管理
                if (isPersonalRepo) {
                    arrangePersonalPage(repository);
                    return;
                }
            }
            if (repoStatus === ErrorCode.NoPermission) {
                if (isPersonalRepo) {
                    arrangePersonalPage(repository);
                    return;
                }
                arrangeRepositoryNoPermission({
                    spaceGuid,
                    groupGuid,
                    repositoryGuid,
                    result,
                });
            }
            if (repoStatus === ErrorCode.NotFound) {
                arrangeRepositoryNotFound({
                    result,
                });
            }
            if (repoStatus === ErrorCode.NoRepository) {
                store.setCurRepositoryError(
                    new WizKnownError('知识库没有找到', 10305, null, '10305')
                );
            }
        } else {
            // preRequest第一次请求catch不到
            store.setCurRepositoryError(
                new WizKnownError('query接口失败', ErrorCode.serverError, null)
            );
        }
    } catch (error: any) {
        if (error.code === ErrorCode.userForbidden) {
            const path = buildPath(routers.Forbidden.path, {});
            location.href = path;
            return;
        }
        if (error.code === ErrorCode.tocUserUnauthorized) {
            const path = buildPath(tocRouters.Unauthorized.path, {});
            location.href = path;
            return;
        }
        store.setCurRepositoryError(error);
        console.log('get repository error:', error);
    }
};

const docPageBuried = (docGuid: string) => {
    const wikiGlobal = (window as any).wikiGlobal;
    if (!wikiGlobal.firstSpaNav) {
        perfLogger.loadTimeDetailed.updateLastLogTime();
    }
    perfLogger.docPagePaint.paintStart({
        firstSpaNav: wikiGlobal.firstSpaNav,
        docGuid,
    });
    wikiGlobal.firstSpaNav = false;
};

const docPageBuriedStop = () => {
    perfLogger.docPagePaint.paintStop();
};

let isPageHidden = false;
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === VISIBILITY_STATE.hidden) {
        isPageHidden = true;
    }
    if (document.visibilityState === VISIBILITY_STATE.visible) {
        isPageHidden = false;
    }
});

export const fetchDocToken = async (
    repository: Repository,
    docGuid: string
) => {
    try {
        // 页面隐藏时不再限制 rteToken 重试，暂先注释
        // if (!canRetryToken) {
        //     return;
        // }
        const res = await tokenRetry<IRteToken>(async (timeout) => {
            const ksServer = await sdk.getKsServer(repository);
            const res = await ksServer.getEditorToken(docGuid, timeout);
            return res;
        });
        const curDocGuid = store.getCurDocument()?.docGuid;
        if (!curDocGuid || (docGuid === curDocGuid)) {
            res && store.setCurDocToken({
                ...res,
                docGuid,
            });
        }
        return res;
    } catch (error) {
        if (error instanceof WizKnownError) {
            let errorMsg = '';
            // 页面不存在或者已被移动
            if (error.code === ErrorCode.NotFound) {
                errorMsg = '页面已被其他人删除或移动，请刷新后重新进入。';
            }
            // 页面五权限
            if (error.code === ErrorCode.NoPermission) {
                errorMsg = '你的权限已经变更，请刷新后重新进入。';
            }
            if (
                error.code === ErrorCode.Duplicate &&
                error.options?.url?.includes('accessTokens')
            ) {
                errorMsg = '文档所属部门知识库已变更，请刷新后重新进入。';
            }
            if (errorMsg) {
                confirm({
                    message: errorMsg,
                    onConfirm: () => {
                        location.reload();
                    },
                });
                return;
            }
        }
        tokenErrorToast();
        if (!isPageHidden) {
            perfLogger.sourceAndApiError.logRteError(error);
        }
    }
};

const isSameRepo = (
    repoA?: {
        spaceGuid: string;
        groupGuid: string;
        repositoryGuid: string;
    },
    repoB?: {
        spaceGuid: string;
        groupGuid: string;
        repositoryGuid: string;
    }
) => {
    if (!repoA || !repoB) {
        return false;
    }
    return (
        repoA.spaceGuid === repoB.spaceGuid &&
        repoA.groupGuid === repoB.groupGuid &&
        repoA.repositoryGuid === repoB.repositoryGuid
    );
};
const getNeedRepositoryData = (repoData: {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
}) => {
    const curRepositoryData = store.getData(store.KEYS.CUR_REPOSITORY);
    const userRepository = sdk.as.userRepository;
    // 如果当前知识库信息 是从首页信息中得来的 那么需要重新加载 否则会导致文档页面出问题
    const isSelfRepo = isSameRepo(repoData, userRepository);
    if (isSelfRepo && !curRepositoryData?.roleName) {
        return true;
    }
    return !curRepositoryData || !isSameRepo(repoData, curRepositoryData);
};

const arrangeDocPageSuccess = (
    result: any,
    pageInfo: {
        spaceGuid: string;
        groupGuid: string;
        repositoryGuid: string;
        docGuid: string;
    }
) => {
    if (result.doc) {
        store.setCurDocument(result.doc);
        result.doc?.type === DOC_TYPE.DOCUMENT &&
            updateDocumentMode(result.doc); // 文档提前设置状态
        const doc = result.doc;
        logAssociations({
            docGuid: doc.docGuid,
            docCreateTime: doc.created,
        });
    }
    store.setCurDocumentError(null);
    store.setCurRepositoryError(null);
    setTimeout(() => {
        const logConst = perfLogger.loadTimeDetailed.const;
        perfLogger.loadTimeDetailed.save(
            logConst.EDITOR_MOUNT_TIME,
            performance.now()
        );
    }, 0);
    // 获取rteToken失败
    if (result.rteToken) {
        store.setCurDocToken({
            docGuid: pageInfo.docGuid,
            accessToken: result.rteToken,
        });
    } else {
        fetchDocToken(
            {
                ...pageInfo,
            },
            pageInfo.docGuid
        );
    }

    const {doc = {}} = result || {};
    setTimeout(() => {
        // 定时器避免拿不到url上的参数
        // 打开页面，剔除数据表夹埋点上报，数据表打开页面埋点在组件内处理
        if (doc.type === DOC_TYPE.DATASHEET) {
            return;
        }

        feLogger(
            openPageUrl({
                pageId: pageInfo.docGuid,
                repoId: pageInfo.repositoryGuid,
                groupId: pageInfo.groupGuid,
                docType: getLogDocType(doc),
                user_type: doc.docRoleName,
            })
        );
    }, 50);
};

const arrangeDocumentNotFound = (result: any) => {
    // 如果是链接错误 则重新跳转
    if (result.wikiInfo) {
        const {spaceGuid, groupGuid, repositoryGuid, docGuid} = result.wikiInfo;
        location.replace(
            getNewUrl(spaceGuid, groupGuid, repositoryGuid, docGuid)
        );
        return;
    }
    const error = new WizKnownError('文档没有找到', 404, null, '404');
    store.setCurDocumentError(error);
};

export const getDocumentInfoFromOld = async (
    repository: Repository,
    docGuid: string
): Promise<
    [
        {
            doc: WizDocument;
            meetingDocs: string[];
        } | null,
        unknown | null
    ]
> => {
    try {
        store.setCurDocument(null);
        store.setShowEditorChildren(false);
        const ksServer = await sdk.getKsServer(repository);
        const [doc, meetingDocs] = await Promise.all([
            ksServer.getDocumentInfo(docGuid),
            getDocsInMeeting(repository),
        ]);
        return [
            {
                doc,
                meetingDocs,
            },
            null,
        ];
    } catch (e) {
        // store.setCurDocumentError(e);
        return [null, e];
    }
};

const arrangeDocumentError = async ({
    repository,
    docGuid,
}: {
    repository: Repository;
    docGuid: string;
}) => {
    store.setCurRepository(repository);
    const wikiGlobal = (window as any).wikiGlobal;
    perfLogger.docPagePaint.paintStart({
        firstSpaNav: wikiGlobal.firstSpaNav,
        docGuid,
    });
    wikiGlobal.firstSpaNav = false;
    const [documentData, error] = await getDocumentInfoFromOld(
        repository,
        docGuid
    );
    if (documentData) {
        // 文档切换时 保证重置
        store.setCurDocToken({
            accessToken: '',
        });
        documentData && store.setDocsInMeeting(documentData?.meetingDocs);
        documentData && store.setCurDocument(documentData?.doc);
        fetchDocToken(repository, docGuid);
        store.setCurDocumentError(null);
    }
};

const updateDocumentMode = (curDocument: any) => {
    // 尽可能早的添加documentMode的值，避免组件多次渲染
    const queryObj = getUrlParams();
    const {editor: queryEditor, isNewDoc} = queryObj!;
    const state: any = history.location.state || {};
    const isHistory = state.isHistory;
    if (curDocument?.isMeetingMode) {
        store.setDocumentMode(
            isHistory ? EDITOR_MODE.history : EDITOR_MODE.meeting
        );
    } else if (queryEditor !== 'icafe_pattern') {
        if (isHistory) {
            store.setDocumentMode(EDITOR_MODE.history);
        } else {
            const docIsCurUser =
                sdk.as.user?.userGuid === curDocument?.userGuid;
            const isNew = state.isNew || (isNewDoc && docIsCurUser);
            const isEdit = state.isEdit || isNew;
            const repository = store.getCurRepository();
            const editable = repository
                ? docEditAble(repository, curDocument)
                : true;
            store.setDocumentMode(
                isEdit && editable ? EDITOR_MODE.edit : EDITOR_MODE.preview
            );
        }
    } else if (queryEditor === 'icafe_pattern') {
        store.setDocumentMode(EDITOR_MODE.edit);

        // 通过各种渠道新建文档，默认展开右侧超级助理
        // setOpenAIChatPanelFlag(AIChatPanelExpandSource.newDoc);
        // setAiChatShow(curDocument?.docGuid);
    }
};

const openPageUrlNoPermissionBuried = (function () {
    let timer: any = null;
    return function (docGuid: any, groupGuid: any, repositoryGuid: any) {
        timer = setTimeout(() => {
            feLogger(openPageUrl({
                pageId: docGuid,
                repoId: repositoryGuid,
                groupId: groupGuid,
                noPermission: 1, // 没有权限
            }));
            clearTimeout(timer); // 埋点后销毁
            timer = null;
        }, 50);
    };
}());

export const getDocumentInfo = async ({
    spaceGuid,
    groupGuid,
    repositoryGuid,
    docGuid,
}: {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
}) => {
    docPageBuried(docGuid);
    const isTocPage = window.isTocPage;
    const needGetRepositoryData = getNeedRepositoryData({
        spaceGuid,
        groupGuid,
        repositoryGuid,
    });
    try {
        // 请求前 先重置下错误状态
        store.setCurDocumentError(null);
        // 重置下rteToken 防止切换知识库时，query接口没有返回rteToken而导致token错乱 放别处不好使
        store.setCurDocToken({
            accessToken: '',
        });
        if (needGetRepositoryData) {
            store.setCurRepositoryName('');
            store.setCurDocument(null);
            store.setCurRepository(null);
            store.setCurRepositoryError(null);
        }
        const result = await sdk.infoQuery({
            spaceGuid,
            groupGuid,
            repositoryGuid,
            docGuid,
            needRepositoryData: needGetRepositoryData,
        });
        if (!result) {
            docPageBuriedStop();
            store.setDocReady(true);
            // preRequest第一次请求异常catch不到
            store.setCurRepositoryError(
                new WizKnownError('query接口失败', ErrorCode.serverError, null)
            );
            return;
        }
        const {repoStatus, docStatus, userRwFlow, rwFlow} = result;
        setRwUnifyData(userRwFlow, rwFlow);
        store.setQueryInfo(result);
        // uuap校验失败 401
        if (docStatus === ErrorCode.uuapExpired) {
            if (isTocPage) {
                // 对外知识库使用passport登陆，跳回登录页验证
                const url = buildPath(tocRouters.Login.path, {});
                const redirectUrl = `${url}?redirect=${encodeURIComponent(window.location.href)}`;
                history.replace(redirectUrl);
            } else {
                location.href = result.uuapJumpUrl;
            }
            return;
        }
        result.user && store.setUser(result.user);
        const docReady = store.getDocReady();
        // 非普通文档不需要等RTE初始化通知
        if (result?.doc?.type !== DOC_TYPE.DOCUMENT && !docReady) {
            store.setDocReady(true);
        }
        // 知识库页面404
        if (repoStatus === ErrorCode.NotFound && needGetRepositoryData) {
            arrangeRepositoryNotFound({result}, docGuid);
            docPageBuriedStop();
            return;
        }
        // 知识库找不到
        if (repoStatus === ErrorCode.NoRepository) {
            store.setCurRepositoryError(
                new WizKnownError('知识库没有找到', 10305, null, '10305')
            );
        }

        // 知识库没有权限 403
        if (repoStatus === ErrorCode.NoPermission && needGetRepositoryData) {
            const repository = result.repository || {};
            const {r, error} = getRepositoryNoPermissionInfo({
                spaceGuid,
                groupGuid,
                repositoryGuid,
                result,
            });
            store.setCurRepositoryName(r.name || repository.repositoryName);
            // 文档没有权限 403
            if (docStatus === ErrorCode.NoPermission) {
                openPageUrlNoPermissionBuried(docGuid, groupGuid, repositoryGuid);
                store.setCurRepository(null);
                // 这里的error对象，code 403
                store.setCurRepositoryError(error);
                docPageBuriedStop();
                return;
            }
            // 文档404
            if (docStatus === ErrorCode.NotFound) {
                // store.setCurRepositoryError code 404
                arrangeRepositoryNotFound({result}, docGuid);
                docPageBuriedStop();
                return;
            }
            if (docStatus === SuccessCode) {
                store.setCurRepository(r);
                arrangeDocPageSuccess(result, {
                    spaceGuid,
                    groupGuid,
                    repositoryGuid,
                    docGuid,
                });
                return;
            }
            return;
        }
        if (needGetRepositoryData && result.repository) {
            fixRepositoryName(result.repository);
            store.setCurRepositoryName(result.repository.name);
            store.setCurRepository({
                ...result.repository,
            });
        }
        // 文档未找到 404
        if (docStatus === ErrorCode.NotFound) {
            // setCurDocumentError 404
            arrangeDocumentNotFound(result);
            docPageBuriedStop();
            return;
        }
        // 获取文档失败 500
        if (docStatus === ErrorCode.serverError) {
            // 这里会请求一些接口做重试
            arrangeDocumentError({
                repository: result.repository,
                docGuid,
            });
            docPageBuriedStop();
            return;
        }
        // 获取文档失败 403
        if (docStatus === ErrorCode.NoPermission) {
            const message = JSON.stringify({
                repositoryName: store.getCurRepository()?.name,
                docName: result.doc?.docName,
                ownerType: result.doc?.ownerType,
            });
            openPageUrlNoPermissionBuried(docGuid, groupGuid, repositoryGuid);
            // setCurDocumentError 403
            store.setCurDocumentError(new WizNoPermissionError(message, null, {
                result: message,
            }));
            docPageBuriedStop();
            return;
        }
        // 其他文档异常状态，非200
        if (docStatus !== SuccessCode) {
            docPageBuriedStop();
            return;
        }
        arrangeDocPageSuccess(result, {
            spaceGuid,
            groupGuid,
            repositoryGuid,
            docGuid,
        });
    } catch (error: any) {
        if (error.code === ErrorCode.userForbidden) {
            const path = buildPath(routers.Forbidden.path, {});
            location.href = path;
            return;
        }
        if (error.code === ErrorCode.tocUserUnauthorized) {
            const path = buildPath(tocRouters.Unauthorized.path, {});
            location.href = path;
            return;
        }
        store.setCurDocumentError(error);
        if (needGetRepositoryData) {
            store.setCurRepositoryError(
                new WizKnownError('query接口失败', ErrorCode.serverError, null)
            );
        }
        console.log('get documentInfo error: ', error);
    }
};

export const arrangeUserRepository = async (
    userGuid: string
): Promise<[string | null, WizKnownError | null]> => {
    try {
        const result: UserDetail = await sdk.as.getUserDetailInfo(userGuid);
        const repository = result.repository;
        if (!repository) {
            throw new Error();
        }
        const path = buildPath(routers.Knowledge.path, {
            spaceGuid: repository.spaceGuid,
            groupGuid: repository.groupGuid,
            repositoryGuid: repository.repositoryGuid,
            docGuid: '',
        });
        return [path, null];
    } catch (err) {
        const error = new WizKnownError(
            '没有该个人知识库',
            ErrorCode.NotFound,
            null
        );
        return [null, error];
    }
};

export const getPersonRepoData = async (userGuid: string, history: any) => {
    const [res, error] = await arrangeUserRepository(userGuid);
    if (res) {
        res && history.replace(res);
        perfLogger.docPagePaint.paintStop();
    } else {
        store.setCurRepositoryError(error);
    }
};

export const getDepartmentInfo = async ({
    spaceGuid,
    groupGuid,
}: {
    spaceGuid: string;
    groupGuid: string;
}) => {
    try {
        const result = await sdk.as.getDepInfo(spaceGuid, groupGuid);
        store.setCurDepartment(result);
        return result;
    } catch (err) {
        console.error('err: ', err);
        store.setCurDepartment(null);
        store.setCurDepartmentError(err);
    }
};
